import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function FundingRepaymentsAmountForm({ fundingRepaymentsSum, fundingRepaymentsCount }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Repayments Amount:</Form.Label>
      </Col>
      <Col md={1} className="bo-same-line">
        <Form.Control
          align="right"
          className="bo-input"
          type="text"
          name="repayment"
          id="repayments"
          value={fundingRepaymentsSum}
          readOnly
        />
      </Col>
      <Col md={2} className="bo-same-line">
        ({fundingRepaymentsCount} repayments)
      </Col>
      <Col md={1} className="bo-same-line" />
    </>
  );
}

export default memo(FundingRepaymentsAmountForm);
